import React from 'react'
import { Question } from 'components/question'
import { QuestionObjectInterface } from 'types/index'
import { ScrollTracking } from '@ta-interaktiv/contentbricks'

import {
  CategoryData,
  FACT_DATA,
  headacheTypes,
  FactDataForCategoryInterface,
  FactDataInterface
} from 'components/_data'
import { FactTable } from 'components/factTable'
import ReactHtmlParser from 'react-html-parser'
import PolymorphicShareButtons, {
  displayTypes
} from '@ta-interaktiv/react-share-buttons'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/accordion.css'
import './styles.scss'

interface Props {
  category: CategoryData
  questions: QuestionObjectInterface[]
  articleID: string
  isMobile?: boolean
  noShare?: boolean
}

let lastNum = 0
export const QuestionCategory = ({
  category,
  questions,
  articleID,
  isMobile = false,
  noShare = false
}: Props) => {
  // let Table = category.Table
  const factDataForCat: FactDataInterface = FACT_DATA.filter(
    (f: { key: headacheTypes; values: FactDataForCategoryInterface[] }) => {
      if (f.key === category.id) return f
    }
  )[0]

  return (
    <>
      <a id={category.id} />
      {category.name !== '' && (
        <div className={'ui relaxed segment categoryTitle ' + category.id}>
          <div className='title'>{ReactHtmlParser(category.name)}</div>
          <img src={require('images/sep_' + category.id + '.png')} />
        </div>
      )}
      {!noShare && (
        <div className='ui text container sharer'>
          <PolymorphicShareButtons
            articleId={articleID}
            hashtags={['TAGrafik', 'ddj']}
            displayType={displayTypes.HORIZONTAL_ICONS}
          />
        </div>
      )}
      {factDataForCat && <FactTable data={factDataForCat} />}

      <div className='ui relaxed segment categorySegment'>
        <div className='ui container'>
          {!isMobile && (
            <div className='ui centered grid'>
              {questions.map((question, i) => {
                lastNum++
                question.lastNum = lastNum
                return (
                  <React.Fragment key={i}>
                    {question.id === '15' && (
                      <ScrollTracking label='content25' />
                    )}
                    {question.id === '25' && (
                      <ScrollTracking label='content50' />
                    )}
                    {question.id === '48' && (
                      <ScrollTracking label='content75' />
                    )}
                    {question.colType === 'narrow' && (
                      <div className='eight wide column' key={i}>
                        <Question data={question} articleID={articleID} />
                      </div>
                    )}
                    {question.colType === 'wide' && (
                      <>
                        <div className='twelve wide column' key={i}>
                          <Question data={question} articleID={articleID} />
                        </div>
                      </>
                    )}
                  </React.Fragment>
                )
              })}
            </div>
          )}
          {isMobile && (
            <div className='ui fluid accordion'>
              {questions.map((question, i) => {
                lastNum++
                question.lastNum = lastNum

                return (
                  <>
                    {question.id === '14' && (
                      <ScrollTracking label='content25' />
                    )}
                    {question.id === '51' && (
                      <ScrollTracking label='content50' />
                    )}
                    {question.id === '35' && (
                      <ScrollTracking label='content75' />
                    )}
                    <Question
                      key={i}
                      isMobile
                      data={question}
                      articleID={articleID}
                    />
                  </>
                )
              })}
            </div>
          )}
        </div>
      </div>
    </>
  )
}
